document.addEventListener('DOMContentLoaded', () => {

  setTimeout(() => {
    // === Автозапуск капсулы при переходе ===
    const capsuleProductId = localStorage.getItem('capsuleSelectionProductId');

    if (capsuleProductId) {
      // Ищем карточку соответствующей капсулы на странице
      const capsuleCard = document.querySelector(`.product-grid__item[data-capsule="${capsuleProductId}"], 
                                                  .product-card[data-product-id="${capsuleProductId}"]`);

      if (capsuleCard) {
        const editBtn = capsuleCard.querySelector('.capsule-edit-button, .capsule-add-full-button');

        if (editBtn) {
          editBtn.click(); // имитируем клик — откроется 2 этап
        }
      }

      setTimeout(() => {
      // Убираем, чтобы не запускать повторно
      localStorage.removeItem('capsuleSelectionProductId');
      }, 1000);
    }
  }, 1000);

  const storedCapsule = localStorage.getItem('capsuleSelection');

  if (storedCapsule) {
    try {
      const { top, bottom } = JSON.parse(storedCapsule);

      const capsuleList = document.querySelector('.capsule-edit-product-dynamic .capsule-edit-product-list');

      if (capsuleList) {
        [top, bottom].forEach((item, index) => {
          const div = document.createElement('div');
          div.className = 'capsule-edit-product-item';
          div.dataset.id = item.id;
          div.dataset.price = item.price;
          div.dataset.collection = item.collection;
          div.dataset.img = item.img;
          div.style.gridColumn = '3 / span 4';
          div.style.gridRow = `${1 + index * 4} / span 4`;

          div.innerHTML = `
            <img src="${item.img}" alt="" loading="lazy">
            <span class="capsule-edit-product-item-hotspot"><span></span></span>
          `;
          capsuleList.appendChild(div);
        });

        document.querySelector('.capsule-edit-product-dynamic').classList.add('active');

        recalculateTotalPrice();

        document.querySelector('.capsule-first-step-body')?.classList.add('hidden');
        document.querySelector('.capsule-edit-wrapper')?.classList.add('active');

        document.querySelectorAll('.capsule-step').forEach((step, i) =>
          step.classList.toggle('active', i === 1)
        );
      }

      // Удаляем, чтобы не повторно использовать
      localStorage.removeItem('capsuleSelection');
    } catch (err) {
      console.error('Invalid capsuleSelection data', err);
    }
  }
  
  let activeEditProductItem = null;

  const layoutSelector = document.querySelector('.capsule-layout-selector');

  if (layoutSelector) {
    const sliderBtn = layoutSelector.querySelector('.capsule-layout-slider');
    const gridBtn = layoutSelector.querySelector('.capsule-layout-grid');

    const sliderWrapper = document.querySelector('.capsule-slider-wrapper');
    const gridWrapper = document.querySelector('.capsule-grid-wrapper');

    sliderBtn?.addEventListener('click', () => {
      sliderBtn.classList.add('active');
      gridBtn.classList.remove('active');

      sliderWrapper?.classList.add('active');
      gridWrapper?.classList.remove('active');
    });

    gridBtn?.addEventListener('click', () => {
      gridBtn.classList.add('active');
      sliderBtn.classList.remove('active');

      gridWrapper?.classList.add('active');
      sliderWrapper?.classList.remove('active');
    });
  }

  const filtersToggle = document.querySelector('.capsule-facets-toggle');
  const filtersBody = document.querySelector('.facets__filters-wrapper');
  if (filtersToggle && filtersBody) {
    filtersToggle.addEventListener('click', () => {
      filtersBody.classList.toggle('active');
    });
  }

  function recalculateTotalPrice() {
    let total = 0;

    document.querySelectorAll('.capsule-edit-product.active .capsule-edit-product-item').forEach(item => {
      const price = parseFloat((item.dataset.price || '0').replace(/,/g, ''));
      total += price;
    });

    const priceElement = document.querySelector('.capsule-edit-price');
    if (priceElement) {
      const formatted = new Intl.NumberFormat('en-US', {
        style: 'decimal',
        useGrouping: true,
        minimumFractionDigits: 0
      }).format(total);
      priceElement.textContent = `${formatted} AED`;
    }
  }

  document.addEventListener('click', (e) => {

    const filtersToggle = document.querySelector('.capsule-facets-toggle');
    const filtersBody = document.querySelector('.facets__filters-wrapper');

    if (filtersBody && filtersToggle) {
      const isClickInside = filtersBody.contains(e.target) || filtersToggle.contains(e.target);
      if (!isClickInside && filtersBody.classList.contains('active')) {
        filtersBody.classList.remove('active');
      }
    }

    const hideHotspotBtn = e.target.closest('.capsule-edit-hide-hotspot');
    if (hideHotspotBtn) {
      const parentCapsule = hideHotspotBtn.closest('.capsule-edit-product');
      if (!parentCapsule) return;

      const isHidden = parentCapsule.classList.toggle('hide-hotspots');

      // Зміна тексту
      hideHotspotBtn.textContent = isHidden ? 'Show hotspots' : 'Hide hotspots';
    }

    

    const replaceBtn = e.target.closest('.capsule-product-card-replace-btn');
    if (replaceBtn && activeEditProductItem) {
      const card = replaceBtn.closest('.capsule-product-card');
      const newId = card.dataset.id;
      const newImg = card.querySelector('img');

      // 1. Обновляем данные в слоте (в капсуле слева)
      activeEditProductItem.dataset.id = newId;
      activeEditProductItem.dataset.price = (card.dataset.price || '0').replace(/,/g, '');
      activeEditProductItem.dataset.title = card.dataset.title;
      activeEditProductItem.dataset.img = newImg.src;

      const img = activeEditProductItem.querySelector('img');
      if (img && newImg) {
        img.src = newImg.src;
        img.alt = newImg.alt;
        img.style.opacity = "1"; // Возвращаем видимость картинки
      }

      // 2. СИМУЛИРУЕМ КЛИК по слоту
      // Это заставит сработать ваш блок `if (item)`, который:
      // - Поставит этот товар на 1-е место
      // - Скроет кнопку Replace и покажет Delete
      activeEditProductItem.click();

      // 3. Управление шагами (Step 2 активен)
      document.querySelectorAll('.capsule-step').forEach((step, i) => {
        step.classList.toggle('active', i === 1);
      });

      document.querySelector('.capsule-edit-finalize')?.classList.add('hidden');
      document.querySelector('.capsule-form')?.classList.add('hidden');
      document.querySelector('.capsule-review-button')?.classList.remove('hidden');
      document.querySelector('.capsule-edit-right-selector')?.classList.remove('hidden');
      document.querySelector('.capsule-edit-empty')?.classList.add('hidden');

      // 4. Пересчет цены
      recalculateTotalPrice();
    }

    const deleteBtn = e.target.closest('.capsule-product-card-delete-btn');
    if (deleteBtn) {
        const card = deleteBtn.closest('.capsule-product-card');
        if (!card) return;

        if (!activeEditProductItem) {
            const id = card.dataset.id;
            const collection = card.dataset.collection;
            activeEditProductItem =
                document.querySelector(`.capsule-edit-product.active .capsule-edit-product-item[data-id="${id}"]`) ||
                document.querySelector(`.capsule-edit-product.active .capsule-edit-product-item[data-collection="${collection}"]`);
        }

        if (!activeEditProductItem) return;

        const removedId = activeEditProductItem.dataset.id;
        
        // 1. Очищаем данные слота
        activeEditProductItem.dataset.id = ""; 
        activeEditProductItem.dataset.price = "0";
        activeEditProductItem.dataset.img = "";

        // 2. Визуально скрываем картинку в капсуле
        const img = activeEditProductItem.querySelector('img');
        if (img) img.style.opacity = "0"; 

        // 3. Чистим форму (удаляем скрытый инпут этого товара)
        const form = document.querySelector('.capsule-form');
        form?.querySelectorAll(`input[name*="[id]"][value="${removedId}"]`).forEach(i => i.remove());

        // 4. МГНОВЕННОЕ ОБНОВЛЕНИЕ ПРАВОЙ ПАНЕЛИ
        // Мы просто симулируем клик по этому же слоту. 
        // Наш новый код в `if (item)` увидит, что ID пустой, 
        // уберет кнопку Delete и покажет Replace у всех товаров.
        activeEditProductItem.click();

        // 5. Переключение интерфейса на Шаг 2
        document.querySelectorAll('.capsule-step').forEach((s, i) => s.classList.toggle('active', i === 1));
        document.querySelector('.capsule-edit-finalize')?.classList.add('hidden');
        document.querySelector('.capsule-form')?.classList.add('hidden');
        document.querySelector('.capsule-review-button')?.classList.remove('hidden');
        document.querySelector('.capsule-edit-right-selector')?.classList.remove('hidden');

        recalculateTotalPrice();
    }

    const item = e.target.closest('.capsule-edit-product-item');
    if (item) {
      activeEditProductItem = item;
      const heading = document.querySelector('.capsule-edit-right-heading');
      const grid = document.querySelector('.capsule-edit-grid');
      
      // Превращаем NodeList в массив для сортировки
      const allCards = Array.from(document.querySelectorAll('.capsule-edit-grid .capsule-product-card'));

      const collectionName = item.dataset.collection;
      const activeId = item.dataset.id;

      heading.textContent = collectionName || 'Collection';

      // 1. СОРТИРОВКА: Выбранный товар ставим в начало списка
      allCards.sort((a, b) => {
        // Если ID карточки совпадает с активным ID слота — она идет первой
        if (activeId && a.dataset.id === activeId) return -1;
        if (activeId && b.dataset.id === activeId) return 1;
        return 0;
      });

      // 2. ОБНОВЛЕНИЕ СЕТКИ И КНОПОК
      // Очищаем grid и вставляем отсортированные карточки
      grid.innerHTML = '';
      
      allCards.forEach(card => {
        grid.appendChild(card); // Возвращаем карточку в DOM в новом порядке

        if (card.dataset.collection === collectionName) {
          card.classList.add('active');
          
          const replaceBtn = card.querySelector('.capsule-product-card-replace-btn');
          const deleteBtn = card.querySelector('.capsule-product-card-delete-btn');

          // Если это именно тот товар, который сейчас в слоте (и слот не пустой)
          if (activeId && card.dataset.id === activeId) {
            replaceBtn?.classList.add('hidden');
            deleteBtn?.classList.remove('hidden');
          } else {
            // Для всех остальных товаров в категории (или если слот пустой)
            replaceBtn?.classList.remove('hidden');
            deleteBtn?.classList.add('hidden');
          }
        } else {
          card.classList.remove('active');
        }
      });

      // 3. УПРАВЛЕНИЕ ВИДИМОСТЬЮ ПАНЕЛЕЙ
      document.querySelector('.capsule-edit-empty')?.classList.add('hidden');
      document.querySelector('.capsule-edit-right-selector')?.classList.remove('hidden');
      document.querySelector('.capsule-edit-finalize')?.classList.add('hidden');
      document.querySelector('.capsule-review-button')?.classList.remove('hidden');
      document.querySelector('.capsule-form')?.classList.add('hidden');

      document.querySelectorAll('.capsule-step').forEach((step, i) => {
        step.classList.toggle('active', i === 1);
      });
    }

    const reviewBtn = e.target.closest('.capsule-review-button');
    if (reviewBtn) {
      const items = document.querySelectorAll('.capsule-edit-product.active .capsule-edit-product-item');
      const form = document.querySelector('.capsule-form');
      const finalizeGrid = document.querySelector('.capsule-edit-finalize-grid');
      let inputs = form?.querySelectorAll('input');
      if (inputs) {
        inputs.forEach(input => input.remove());
      }

      items.forEach((item, index) => {
        const id = item.dataset.id;
        const title = item.dataset.title;
        const img = item.dataset.img;
        const price = item.dataset.price;
        const options = JSON.parse(item.dataset.options || '[]');

        const inputId = document.createElement('input');
        inputId.type = 'hidden';
        inputId.name = `items[${index}][id]`;
        inputId.value = id;

        const inputQty = document.createElement('input');
        inputQty.type = 'hidden';
        inputQty.name = `items[${index}][quantity]`;
        inputQty.value = '1';

        form.appendChild(inputId);
        form.appendChild(inputQty);

        // Скрыть правую панель и подсказку
        document.querySelector('.capsule-edit-empty')?.classList.add('hidden');
        document.querySelector('.capsule-edit-right-selector')?.classList.add('hidden');

        // Подсветить карточки, которые присутствуют в capsule-edit-product-list
        const selectedIds = Array.from(document.querySelectorAll('.capsule-edit-product.active .capsule-edit-product-item'))
          .map(item => item.dataset.id);

        document.querySelectorAll('.capsule-edit-finalize-grid .capsule-product-card').forEach(card => {
          const cardId = card.dataset.id;
          if (selectedIds.includes(cardId)) {
            card.classList.add('active');
          } else {
            card.classList.remove('active');
          }
        });
      });

      document.querySelectorAll('.capsule-step').forEach((s, i) =>
        s.classList.toggle('active', i === 2)
      );
      document.querySelector('.capsule-first-step-body')?.classList.add('hidden');
      document.querySelector('.capsule-edit-finalize')?.classList.remove('hidden');
      document.querySelector('.capsule-form')?.classList.remove('hidden');
      document.querySelector('.capsule-review-button')?.classList.add('hidden');
    }

    const addFullBtn = e.target.closest('.capsule-add-full-button');
    if (addFullBtn) {
      // Берём capsule handle так же, как в .capsule-edit-button
      const productGridItem = addFullBtn.closest('.product-grid__item');
      const capsuleHandle = productGridItem?.dataset.capsule;

      // Снимаем активность со всех капсул
      document.querySelectorAll('.capsule-edit-product').forEach(b => b.classList.remove('active'));

      // Ищем нужный блок капсулы по handle
      const activeBlock = capsuleHandle
        ? document.querySelector(`.capsule-edit-product[data-capsule="${capsuleHandle}"]`)
        : null;

      if (activeBlock) {
        activeBlock.classList.add('active');
      } else {
        console.warn('Не найден .capsule-edit-product для', capsuleHandle);
      }

      // === Переносим товары в форму (как в review) ===
      const items = activeBlock
        ? activeBlock.querySelectorAll('.capsule-edit-product-item')
        : document.querySelectorAll('.capsule-edit-product.active .capsule-edit-product-item');

      const form = document.querySelector('.capsule-form');

      // Чистим старые инпуты
      form?.querySelectorAll('input').forEach(input => input.remove());

      // Создаём новые hidden inputs по выбранным позициям
      Array.from(items).forEach((item, index) => {
        const id = item.dataset.id;

        const inputId = document.createElement('input');
        inputId.type = 'hidden';
        inputId.name = `items[${index}][id]`;
        inputId.value = id;

        const inputQty = document.createElement('input');
        inputQty.type = 'hidden';
        inputQty.name = `items[${index}][quantity]`;
        inputQty.value = '1';

        form?.appendChild(inputId);
        form?.appendChild(inputQty);
      });

      // Подсветка выбранных карточек в финальной сетке
      const selectedIds = Array.from(items).map(i => i.dataset.id);
      document.querySelectorAll('.capsule-edit-finalize-grid .capsule-product-card').forEach(card => {
        card.classList.toggle('active', selectedIds.includes(card.dataset.id));
      });

      // === Переключаемся сразу на 3-й шаг ===
      document.querySelectorAll('.capsule-step').forEach((step, i) => {
        step.classList.toggle('active', i === 2);
      });
      document.querySelector('.capsule-first-step-body')?.classList.add('hidden');
      document.querySelector('.capsule-edit-wrapper')?.classList.add('active');
      document.querySelector('.capsule-edit-finalize')?.classList.remove('hidden');
      document.querySelector('.capsule-form')?.classList.remove('hidden');
      document.querySelector('.capsule-review-button')?.classList.add('hidden');
      document.querySelector('.capsule-edit-right-selector')?.classList.add('hidden');
      document.querySelector('.capsule-edit-empty')?.classList.add('hidden');

      // Пересчёт цены
      recalculateTotalPrice();

      return;
    }

    // 7. Клик по КАРТОЧКЕ или кнопке EDIT (Шаг 1 -> Шаг 2)
    const capsuleTrigger = e.target.closest('.product-grid__item[data-capsule], .capsule-edit-button');
    
    if (capsuleTrigger) {
      // ИСКЛЮЧЕНИЕ: Если кликнули по ПРАВОЙ ПАНЕЛИ редактора (выбор товаров), не перезапускаем капсулу
      if (e.target.closest('.capsule-edit-right-selector')) return;

      // Если кликнули по блоку покупки, но ЭТО НЕ кнопка редактирования — тогда выходим (даем работать кнопкам корзины)
      // Если же кликнули именно по .capsule-edit-button, то пропускаем код дальше
      if (e.target.closest('.buy-buttons-block') && !e.target.closest('.capsule-edit-button')) {
        return;
      }

      const productGridItem = capsuleTrigger.closest('.product-grid__item');
      // В вашем HTML в product-card нет data-capsule, используем data-product-id как запасной вариант
      const capsuleHandle = productGridItem?.dataset.capsule || productGridItem?.dataset.productId;
      const capsuleTitle = productGridItem?.querySelector('.product-card-title')?.textContent?.trim();

      if (!capsuleHandle) return;

      const capsuleEditProducts = document.querySelectorAll('.capsule-edit-product');
      capsuleEditProducts.forEach(block => block.classList.remove('active'));

      const activeBlock = document.querySelector(`.capsule-edit-product[data-capsule="${capsuleHandle}"]`);
      if (activeBlock) {
        activeBlock.classList.add('active');

        const editHeading = document.querySelector('.capsule-edit-content h2');
        if (editHeading && capsuleTitle) {
          editHeading.textContent = capsuleTitle;
        }
        
        recalculateTotalPrice();
      }

      document.querySelector('.capsule-edit-wrapper')?.classList.add('active');
      document.querySelector('.capsule-first-step-body')?.classList.add('hidden');

      document.querySelectorAll('.capsule-step').forEach((step, i) => {
        step.classList.toggle('active', i === 1);
      });

      return;
    }
  });

  document.addEventListener('change', (e) => {
    const select = e.target.closest('.capsule-product-card-options select');
    if (!select) return;

    const card = select.closest('.capsule-product-card');
    const allSelects = card.querySelectorAll('select');

    // Получаем все выбранные значения по порядку
    const selectedOptions = Array.from(allSelects).map(sel => sel.value);

    if (selectedOptions.includes('Select')) return; // не все выбраны

    // Получаем все варианты
    const variantsJson = card.dataset.variants;
    let variants = [];
    try {
      variants = JSON.parse(variantsJson);
    } catch (e) {
      console.warn('Invalid variant data', e);
      return;
    }

    // Сравниваем с вариантом
    const matched = variants.find(v => {
      return v.options.every((opt, idx) => opt === selectedOptions[idx]);
    });

    if (matched) {
      const newId = matched.id;

      // Обновляем data-id карточки
      const oldId = card.dataset.id;

      // Присваиваем новый id карточке
      card.dataset.id = newId;

      // Обновляем hidden input в форме
      const input = document.querySelector(`.capsule-form input[name*="[id]"][value="${oldId}"]`);
      if (input) {
        input.value = newId;
      }
    }
  });

  const capsuleSlider = document.querySelector('.capsule-slider');
  if (capsuleSlider) {
    new Swiper(capsuleSlider, {
      loop: true,
      centeredSlides: true,
      slidesPerView: 1,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      }
    });
  }
});
